export enum OrderActionStatus {
    none = 0,
    ordered = 1,
    pending = 2,
    canceled = 3,
    received = 4,
    done = 5
}
